import Dbm from "dbm";
import Website from "../../index.js";

export default class ProgressBar extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);

        let animationLayer = Dbm.flow.externalObject(new PIXI.Container());
        animationLayer.addProperty("scale", 1);
        animationLayer.addProperty("alpha", 0);
        animationLayer.object.alpha = 0;
        container.addChild(animationLayer.object);
        this.item.setValue("animationLayer", animationLayer.item);
        
        const graphics = new PIXI.Graphics();
        animationLayer.object.addChild(graphics);
        this.item.setValue("graphics", graphics);

        this.item.setValue("width", 100);
        this.item.setValue("percentage", 0);
        this.item.setValue("color", 0xFFFFFF);
    }

    update(aTime, aDelta) {
        //console.log("update");

        let graphics = this.item.graphics;

        graphics.clear();

        let width = this.item.width;
        let height = 8;

        this.item.animationLayer.object.position.x = 0.5*width;
        this.item.animationLayer.object.position.y = 0.5*height;

        this.item.graphics.position.x = -0.5*width;
        this.item.graphics.position.y = -0.5*height;

        graphics.beginFill(this.item.color);
        graphics.drawRect(0, 2, 1, height-2*2);
        graphics.endFill();

        graphics.beginFill(this.item.color);
        graphics.drawRect(1, 1, 1, 1);
        graphics.endFill();

        graphics.beginFill(this.item.color);
        graphics.drawRect(2, 0, this.item.width-2*2, 1);
        graphics.endFill();

        graphics.beginFill(this.item.color);
        graphics.drawRect(width-2, 1, 1, 1);
        graphics.endFill();

        graphics.beginFill(this.item.color);
        graphics.drawRect(width-1, 2, 1, height-2*2);
        graphics.endFill();

        graphics.beginFill(this.item.color);
        graphics.drawRect(width-2, height-2, 1, 1);
        graphics.endFill();
        
        graphics.beginFill(this.item.color);
        graphics.drawRect(2, height-1, this.item.width-2*2, 1);
        graphics.endFill();        

        graphics.beginFill(this.item.color);
        graphics.drawRect(1, height-2, 1, 1);
        graphics.endFill();

        let percentage = this.item.percentage
        let progressLength = Math.max(4, Math.round((width-2*2)*percentage));

        graphics.beginFill(this.item.color);
        graphics.drawRect(2+1, 2, progressLength-2, height-2*2);
        graphics.endFill();

        graphics.beginFill(this.item.color);
        graphics.drawRect(2, 2+1, progressLength, height-2*3);
        graphics.endFill();
    }
}